import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  layoutColor: "default",
  layoutMode: "light",
  layoutType: "vertical",
  layoutWidth: "fluid",
  leftSideBarTheme: "dark",
  leftSideBarType: "default",
  topbarTheme: "light",
  isPreloader: false,
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
}

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    changeLayout(state, action) {
      state.layoutType = action.payload
    },
    changeColor(state, action) {
      state.layoutColor = action.payload
    },
    changeMode(state, action) {
      state.layoutMode = action.payload
    },
    changePreloader(state, action) {
      state.isPreloader = action.payload
    },
    changeLayoutWidth(state, action) {
      state.layoutWidth = action.payload
    },
    changeSidebarTheme(state, action) {
      state.leftSideBarTheme = action.payload
    },
    changeSidebarType(state, action) {
      // Поддерживаем два вызова: dispatch(changeSidebarType({ sidebarType, isMobile }))
      // и dispatch(changeSidebarType("compact")) — прямая строка
      // FIX: прямая строка как payload не должна падать с TypeError
      if (action.payload && typeof action.payload === 'object') {
        // Обновляем только если sidebarType явно передан
        if (action.payload.sidebarType !== undefined) {
          state.leftSideBarType = action.payload.sidebarType
        }
      } else if (typeof action.payload === 'string') {
        state.leftSideBarType = action.payload
      }
    },
    changeTopbarTheme(state, action) {
      state.topbarTheme = action.payload
    },
    showRightSidebar(state, action) {
      state.showRightSidebar = action.payload
    },
    showSidebar(state, action) {
      state.showSidebar = action.payload
    },
    toggleLeftmenu(state, action) {
      state.leftMenu = action.payload
    },
  },
})

export const {
  changeLayout,
  changeColor,
  changeMode,
  changePreloader,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  showRightSidebar,
  showSidebar,
  toggleLeftmenu,
} = layoutSlice.actions

export default layoutSlice.reducer
